import { t } from "../i18n/index.js";
import { weaponName } from "../ui/labels.js";

// 格納庫: 試合で稼いだ DOPA で買う、ずっと続く強化。
// 効き目は試合の前に createWorld の meta(world.params)へ渡すので、リプレイ・R.W.N.D.も同じになる。
// R.W.N.D.の回数だけは試合の外(src/main.js)で数える。
// 名前・説明は src/i18n/ の hangar.<id>.name・hangar.<id>.desc。

export const HANGAR = {
  // 2026-10-31 オーナー決定「面が進んでも自機の初期値は自動で上げず、ここの強化だけで強くなる」ので、4〜6面に合わせて段数を多めにしてある
  shield: { per: 0.1, costs: [120, 300, 600, 1000, 1600, 2300, 3100, 4000, 5000, 6200] },
  power: { per: 0.08, costs: [150, 350, 700, 1100, 1700, 2400, 3200, 4100, 5100, 6300] },
  xpGain: { per: 0.08, costs: [150, 350, 700, 1100, 1700, 2400, 3200, 4100, 5100, 6300] },
  magnet: { per: 0.15, costs: [100, 300, 700] },
  rewind: { per: 1, costs: [800, 2000] },
};

export function levelOf(save, id) {
  return save.upgrades[id] || 0;
}

// 次のレベルの値段(もう最大なら null)
export function nextCost(save, id) {
  return HANGAR[id].costs[levelOf(save, id)] ?? null;
}

export function buy(save, id) {
  const cost = nextCost(save, id);
  if (cost == null || save.dopa < cost) return false;
  save.dopa -= cost;
  save.upgrades[id] = levelOf(save, id) + 1;
  return true;
}

// 今の強化の効き目を文にする(例「+20%」「+1回」)
export function effectText(id, level) {
  const u = HANGAR[id];
  if (id === "rewind") return t("hangar.rewindEffect", { n: level * u.per });
  return `+${Math.round(level * u.per * 100)}%`;
}

// 試合に持っていく倍率(createWorld の meta)と、R.W.N.D.の追加回数
export function bonusesFor(save) {
  const mult = (id) => 1 + levelOf(save, id) * HANGAR[id].per;
  return {
    meta: { shield: mult("shield"), power: mult("power"), xpGain: mult("xpGain"), magnet: mult("magnet") },
    extraRewind: levelOf(save, "rewind") * HANGAR.rewind.per,
  };
}

// 最初から持って出られる武器(目標の達成で解放。src/meta/goals.js の unlock)
export function startWeaponName(id) {
  return weaponName(id);
}
